/**
 * _restaurantDemo.constants.ts — Horarios demo restaurante (desayuno, almuerzo, extras).
 *
 * Usado por rest.ts, desayuno.ts y extras.ts al cargar el catálogo demo.
 */
import type { DisponibilidadHoraria, ModifierGroup } from "@/types";

/** Desayuno: 7:00 – 11:00 */
export const HORARIO_DESAYUNO: DisponibilidadHoraria = {
  modo: "restringido",
  horaInicio: "07:00",
  horaFin: "11:00",
};

/** Almuerzo: 11:00 – 16:00 */
export const HORARIO_ALMUERZO: DisponibilidadHoraria = {
  modo: "restringido",
  horaInicio: "11:00",
  horaFin: "16:00",
};

/** Extras: 7:00 – 16:00 */
export const HORARIO_EXTRAS: DisponibilidadHoraria = {
  modo: "restringido",
  horaInicio: "07:00",
  horaFin: "16:00",
};

type DemoProductInput = {
  gruposModificadores?: ModifierGroup[];
  modificadoresValidacionCaja?: "completa" | "libre";
};

/**
 * Demo restaurante: artículos con personalización (precio base + extras)
 * quedan en «Libre en caja» salvo override explícito.
 */
export const withDemoCajaLibreIfModifiers = <T extends DemoProductInput>(
  input: T,
): T => {
  const hasModifiers = (input.gruposModificadores?.length ?? 0) > 0;
  if (!hasModifiers || input.modificadoresValidacionCaja) return input;
  return { ...input, modificadoresValidacionCaja: "libre" };
};
